import NodeDetailsHeader from './NodeDetailsHeader';

export default NodeDetailsHeader;
